/** Palette for the Result tab: one colour per planned route, map and table. */
export const routeColours = [
  '#e8371d',
  '#4bc9b0',
  '#3b82f6',
  '#f2c500',
  '#d946ef',
  '#00cc7e',
  '#F97316',
  '#CC338B',
  '#0000EE',
  '#22c55e',
  '#1E3A5F',
  '#6e7074',
];

export const routeColour = (index: number) =>
  routeColours[index % routeColours.length];
